/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkUrlstatus } from "../../funcs/networkGetNetworkUrlstatus.js";
import { GetNetworkUrlstatusRequest$zodSchema } from "../../models/getnetworkurlstatusop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkUrlstatusRequest$zodSchema,
};

export const tool$networkGetNetworkUrlstatus: ToolDefinition<typeof args> = {
  name: "network-get-network-urlstatus",
  description: `检查URL的可访问性状态

你的网站或API还好吗？用这个接口给它做个快速“体检”吧。

## 功能概述
提供一个URL，我们会向它发起一个请求，并返回其HTTP响应状态码。这是一种简单而有效的服务可用性监控方法。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkUrlstatus(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
